<template>
    <div class="buy-3s-success">
        <div class="main">
            <div class="top-block">
                <div class="success-tip">
                    <img mode="widthFixed" class="icon"
                        src="https://tc-nj-backend-ms-pub-cdn.mobvoi.com/rd2-cdn/moyin-mini/associate-member/succ-icon.png" />
                    <div class="desc">
                        <div class="con">恭喜您激活成功！</div>
                        <div class="rights">3秒克隆发音人</div>
                    </div>
                </div>

                <div class="member-card">
                    <div class="rights">3秒克隆发音人*1位</div>
                    <div class="account">账号：{{ formatPhone(phoneNumber) }}</div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            phoneNumber: ''
        }
    },
    mounted() {
        const { phoneNumber } = this.$route.query
        this.phoneNumber = phoneNumber
    },
    methods: {
        formatPhone(phone) {
            if (!phone) return ''
            return phone.slice(0, 3) + ' ' + phone.slice(3, 7) + ' ' + phone.slice(7)
        }
    }
}
</script>
<style lang="less">
.fc {
    display: flex;
    align-items: center;
    justify-content: center;
}

.buy-3s-success {
    height: 100%;
    background: #F5F5F7;

    .top-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 750px;
        height: 738px;
        background: no-repeat url(https://tc-nj-backend-ms-pub-cdn.mobvoi.com/rd2-cdn/moyin-mini/associate-member/succ-top-bg.png) top/100% 100%;
        box-sizing: border-box;
        padding-top: 128px;

        .success-tip {
            .fc();
            height: 112px;

            .icon {
                margin-right: 32px;
                width: 88px;
                height: 88px;
            }

            .desc {
                .con {
                    font-family: HarmonyOS_Sans_SC_Medium;
                    font-size: 40px;
                    color: #001126;
                    line-height: 56px;
                }

                .rights {
                    margin-top: 8px;
                    font-family: HarmonyOS_Sans_SC_Medium;
                    font-size: 32px;
                    color: #596472;
                    line-height: 48px;
                }
            }
        }

        .member-card {
            margin-top: 64px;
            background: no-repeat url(https://tc-nj-backend-ms-pub-cdn.mobvoi.com/rd2-cdn/moyin-mini/associate-member/card.png) center/cover;
            width: 588px;
            height: 218px;
            box-sizing: border-box;
            padding: 30px 40px;

            .rights {
                font-family: HarmonyOS_Sans_SC_Bold;
                font-size: 32px;
                color: #B0663A;
                line-height: 48px;
                text-shadow: 0px 4px 4px rgba(255, 255, 255, 0.8);
            }

            .account {
                margin-top: 16px;
                font-family: HarmonyOS_Sans_SC;
                font-size: 24px;
                color: #B27E5F;
                line-height: 40px;
            }
        }
    }


}
</style>